
import { mapGetters } from "vuex";
import backButtonOutlined from "../common/back-button-outlined.vue";
import MenuHeaderMenuFormatter from "./menu-header-menu-formatter.vue";
import MenuHeaderViewToggler from "./menu-header-view-toggler.vue";
import MenuItemAddBtn from "../menu/menu-item-add-btn.vue";
import MenuHeaderAllBrands from "../menu/menu-header-all-brands.vue";
import MenuHeaderOptionsTile from "../menu/menu-header-options-tile.vue";
import OutlinedBtn from "../common/outlined-btn.vue";
import MenuHeaderSearchField from "./menu-header-search-field.vue";
import BackButtonFullHeight from "../common/back-button-full-height.vue";
import MenuShare from "./menu-share.vue";
import MenuHeaderChargesTile from "./menu-header-charges-tile.vue";
import MenuAddDropdown from "./menu-add-dropdown.vue";
import CreateEditAddonDialog from "../dialogs/create-edit-addon-dialog.vue";
export default {
  components: {
    backButtonOutlined,
    MenuHeaderMenuFormatter,
    MenuHeaderViewToggler,
    MenuItemAddBtn,
    MenuHeaderAllBrands,
    MenuHeaderOptionsTile,
    OutlinedBtn,
    MenuHeaderSearchField,
    BackButtonFullHeight,
    MenuShare,
    MenuHeaderChargesTile,
    MenuAddDropdown,
    CreateEditAddonDialog
  },
  props: {
    hasNoMenuData: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showOptionsTile: false,
      showAdditionalCharges: false,
      menuItems: [{ text: "Import Menu", to: "/menu/upload" }],
      showCreateAddonDialog: false
    };
  },

  computed: {
    ...mapGetters("restaurant", ["hasMultipleBrands"]),
    ...mapGetters("menu", ["syncPendingTotalCount"])
  },
  methods: {
    handleshowCreateAddonDialog() {
      this.showCreateAddonDialog = true;
    }
  }
};
